export const groupSeatingData = () => {
  return [
    {
      title: "all general group seating areas",
      color: "",
      earlyBird: "",
      regular: "",
      class: "allAreas",
      map: require("@/assets/images/GroupMaps/main-map-2.jpg"),
      active: true,
    },
    {
      title: "select infield mezzanine",
      color: "#5e101d",
      // earlyBird: "39",
      regularOnlyStart: "74",
      class: "selectInfieldMezzanine",
      map: require("@/assets/images/GroupMaps/select-infield-mezzanine.jpg"),
      description: "",
      sections: "SECTIONS <span>107-121</span><br>ROWS <span>2-10</span>",
      // capacity: "16-156",
      price:
        "price per ticket starting at <span>$74</span>*<br>ticket with loaded value starting at <span>$89</span>*",
      // "price per ticket starting at <span>$74</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "infield mezzanine",
      color: "#c40f30",
      // earlyBird: "39",
      regularOnlyStart: "66",
      class: "infieldMezzanine",
      map: require("@/assets/images/GroupMaps/mezzanine-2.jpg"),
      description: "",
      sections: "SECTIONS <span>107-121</span><br>ROWS <span>11-20</span>",
      // capacity: "16-156",
      price:
        "price per ticket starting at <span>$66</span>*<br>ticket with loaded value starting at <span>$81</span>*",
      // "price per ticket starting at <span>$66</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "all you can eat",
      color: "#f03645",
      // earlyBird: "32",
      regularOnlyStart: "50",
      class: "allYouCanEat",
      map: require("@/assets/images/GroupMaps/map_all-you-can-eat.jpg"),
      description:
        "This Rangers fan-favorite space offers a spectacular view from lower left field, along with a ticket that includes all-you-can eat items like grilled chicken sandwiches, hamburgers, hot dogs, nachos, peanuts, popcorn, and unlimited soft drinks.",
      // heading: "new location for 2022!",
      sections: "SECTIONS <span>27-33</span>",
      capacity: "",
      // price: "price per 4 tickets <span>$000.00</span>.",
      // legal: "(Sold in increments of 4 seats)",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner box",
      color: "#e6e7e6",
      // earlyBird: "28",
      regularOnlyStart: "44",
      class: "cornerBox",
      map: require("@/assets/images/GroupMaps/map_corner-box-2.jpg"),
      description: "",
      sections: "SECTIONS <span>1-4, 22-25</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$44</span>*<br>ticket with loaded value starting at <span>$59</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "mezzanine",
      color: "#f59666",
      // earlyBird: "24",
      regularOnlyStart: "38",
      class: "mezzanine",
      map: require("@/assets/images/GroupMaps/mezzanine.jpg"),
      description: "",
      sections: "SECTIONS <span>104-106, 122-124</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$38</span>*<br>ticket with loaded value starting at <span>$53</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "infield pavilion",
      color: "#b69168",
      // earlyBird: "22",
      regularOnlyStart: "36",
      // soldOut: true,
      class: "infieldPavilion",
      map: require("@/assets/images/GroupMaps/map_infield-pavilion.jpg"),
      description: "",
      sections: "SECTIONS <span>214-220</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$36</span>*<br>ticket with loaded value starting at <span>$51</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner mezzanine",
      color: "#ffdd00",
      // earlyBird: "24",
      regularOnlyStart: "33",
      class: "mezzanine",
      map: require("@/assets/images/GroupMaps/corner-mezzanine.jpg"),
      description: "",
      sections: "SECTIONS <span>101-103, 125-127</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$33</span>*<br>ticket with loaded value starting at <span>$48</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "sky box",
      color: "#7cc242",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "skyBox",
      map: require("@/assets/images/GroupMaps/skybox.jpg"),
      description:
        // "This spacious area located in a more exclusive area behind the seats in left field, offers plenty of room for your group to mingle with convenient access to concessions. The perfect space to host a semi-private picnic (groups of 50-225) with a spectacular view of the game.",
        "",
      sections: "SECTIONS <span>SB1-SB4</span>",
      // capacity: "50-225+",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // legal: "(Sold in increments of 4 seats)",
      carousel: [require("@/assets/images/PartyAreas/sky-box/sky-box-01.jpeg")],
      active: false,
    },
    {
      title: "outfield mezzanine",
      color: "#dc6027",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "outfieldMezzanine",
      map: require("@/assets/images/GroupMaps/map_outifled-mezzanine-2.jpg"),
      description: "",
      sections: "SECTIONS <span>128-133, 136-142</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "budweiser sky porch",
      color: "#bc57a2",
      // earlyBird: "14",
      regularOnlyStart: "23",
      class: "skyPorch",
      map: require("@/assets/images/GroupMaps/karbach-brewing-sky-porch.jpg"),
      // description:
      //   "The Karbach Brewing Sky Porch, located in the left field mezzanine of the Upper Concourse, is an open space to socialize, perfect for corporate outings, family reunions or birthday celebrations.",
      sections: "SECTIONS <span>201-204</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$23</span>*<br>ticket with loaded value starting at <span>$38</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "baseline pavilion",
      color: "#002d73",
      // earlyBird: "17",
      regularOnlyStart: "28",
      class: "baselinePavilion",
      map: require("@/assets/images/GroupMaps/map_baseline-pavilion.jpg"),
      description: "",
      sections: "SECTIONS <span>208-213, 221-228</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$28</span>*<br>ticket with loaded value starting at <span>$43</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "corner pavilion",
      color: "#7f8133",
      // earlyBird: "12",
      regularOnlyStart: "20",
      class: "cornerPavilion",
      map: require("@/assets/images/GroupMaps/map_corner-pavilion.jpg"),
      description: "",
      sections: "SECTIONS <span>205-207, 229-232</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$20</span>*<br>ticket with loaded value starting at <span>$35</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "outfield pavilion",
      color: "#f4f1ae",
      // earlyBird: "10",
      regularOnlyStart: "17",
      class: "outfieldPavilion",
      map: require("@/assets/images/GroupMaps/map_outfield-pavilion.jpg"),
      description: "",
      sections: "SECTIONS <span>233-244</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$17</span>*<br>ticket with loaded value starting at <span>$32</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "upper box",
      color: "#f7acbb",
      // earlyBird: "10",
      regularOnlyStart: "17",
      class: "upperBox",
      map: require("@/assets/images/GroupMaps/map_upper-box.jpg"),
      description: "",
      sections: "SECTIONS <span>308-317</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$17</span>*<br>ticket with loaded value starting at <span>$32</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
    {
      title: "upper reserved",
      color: "#75cac3",
      // earlyBird: "9",
      regularOnlyStart: "14",
      class: "upperReserved",
      map: require("@/assets/images/GroupMaps/map_upper-reserved.jpg"),
      description: "",
      sections: "SECTIONS <span>301-307, 318-324</span>",
      // capacity: "0",
      price:
        "price per ticket starting at <span>$14</span>*<br>ticket with loaded value starting at <span>$29</span>*",
      legal: "*Applicable fees and taxes to be added at time of purchase.",
      // carousel: [
      //     require("@/assets/images/PartyAreas/header_1.jpg"),
      //     require("@/assets/images/PartyAreas/header_2.jpg"),
      // ],
      active: false,
    },
  ];
};
